import React from 'react';
import { useField, ErrorMessage } from 'formik';
import Select from 'react-select';
import { normalizeState } from '../../utils/patientForm';

export const US_STATES = [
  {value:'AL',label:'Alabama'},{value:'AK',label:'Alaska'},{value:'AZ',label:'Arizona'},{value:'AR',label:'Arkansas'},
  {value:'CA',label:'California'},{value:'CO',label:'Colorado'},{value:'CT',label:'Connecticut'},{value:'DE',label:'Delaware'},
  {value:'FL',label:'Florida'},{value:'GA',label:'Georgia'},{value:'HI',label:'Hawaii'},{value:'ID',label:'Idaho'},
  {value:'IL',label:'Illinois'},{value:'IN',label:'Indiana'},{value:'IA',label:'Iowa'},{value:'KS',label:'Kansas'},
  {value:'KY',label:'Kentucky'},{value:'LA',label:'Louisiana'},{value:'ME',label:'Maine'},{value:'MD',label:'Maryland'},
  {value:'MA',label:'Massachusetts'},{value:'MI',label:'Michigan'},{value:'MN',label:'Minnesota'},{value:'MS',label:'Mississippi'},
  {value:'MO',label:'Missouri'},{value:'MT',label:'Montana'},{value:'NE',label:'Nebraska'},{value:'NV',label:'Nevada'},
  {value:'NH',label:'New Hampshire'},{value:'NJ',label:'New Jersey'},{value:'NM',label:'New Mexico'},{value:'NY',label:'New York'},
  {value:'NC',label:'North Carolina'},{value:'ND',label:'North Dakota'},{value:'OH',label:'Ohio'},{value:'OK',label:'Oklahoma'},
  {value:'OR',label:'Oregon'},{value:'PA',label:'Pennsylvania'},{value:'RI',label:'Rhode Island'},{value:'SC',label:'South Carolina'},
  {value:'SD',label:'South Dakota'},{value:'TN',label:'Tennessee'},{value:'TX',label:'Texas'},{value:'UT',label:'Utah'},
  {value:'VT',label:'Vermont'},{value:'VA',label:'Virginia'},{value:'WA',label:'Washington'},{value:'WV',label:'West Virginia'},
  {value:'WI',label:'Wisconsin'},{value:'WY',label:'Wyoming'},{value:'DC',label:'District of Columbia'},
  {value:'PR',label:'Puerto Rico'},{value:'GU',label:'Guam'},{value:'VI',label:'U.S. Virgin Islands'},
  {value:'AS',label:'American Samoa'},{value:'MP',label:'Northern Mariana Islands'}
];

// Display 'FL — Florida', store 'FL'; search matches either.
export const stateOptionLabel = (s) => `${s.value} — ${s.label}`;
const filterState = (opt, input) => {
  const q = (input || '').trim().toLowerCase();
  return !q || opt.data.value.toLowerCase().startsWith(q) || opt.data.label.toLowerCase().includes(q);
};
export const stateOption = (v) => US_STATES.find((s) => s.value === normalizeState(v)) || null;

/** Controlled (non-Formik) variant; legacy free-text values ('Florida', 'fl') resolve to their code. */
export const StateSelect = ({ value, onChange, label = 'State', compulsory, inputId = 'state', error }) => (
  <div className="mb-2">
    <label htmlFor={inputId} className="form-label mt-3">{label} {compulsory ? <span style={{ color: 'red', fontWeight: 'bold' }}> *</span> : null}</label>
    <Select inputId={inputId} options={US_STATES} value={stateOption(value)} getOptionLabel={stateOptionLabel} filterOption={filterState}
      onChange={(opt) => onChange(opt ? opt.value : '')} placeholder="Select or type a state..." isClearable />
    {value && !stateOption(value) ? <small className="text-warning">Saved value “{value}” is not a USPS state — pick one.</small> : null}
    {error ? <div className="error">{error}</div> : null}
  </div>
);

const StateSelectBox = ({ label, compulsory, name, placeholder }) => {
  const [field, meta, helpers] = useField(name);
  const selected = stateOption(field.value);
  return (
    <div className="mb-2">
      <label className="form-label mt-3">{label} {compulsory === true ? <span style={{ color: 'red', fontWeight: 'bold' }}> *</span> : null}</label>
      <Select
        inputId={name}
        options={US_STATES}
        value={selected}
        getOptionLabel={stateOptionLabel}
        filterOption={filterState}
        onChange={(opt) => helpers.setValue(opt ? opt.value : '')}
        onBlur={() => helpers.setTouched(true)}
        placeholder={placeholder || 'Select or type a state...'}
        isClearable
      />
      <ErrorMessage component="div" name={name} className="error" />
    </div>
  );
};
export default StateSelectBox;
